<template>
  <div class="wrap-lg">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>法律法规</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10">
      <el-col :span="18">
        <el-card shadow="hover">
          <div>
            <el-input
              style="width: 380px;"
              class="inline-input"
              v-model="searchText"
              @keyup.enter.native="mockData"
              prefix-icon="el-icon-search"
              placeholder="关键字"
            >
              <el-button slot="append" :loading="loading" @click="mockData">搜索</el-button>
            </el-input>
          </div>
        </el-card>
        <el-card style="margin-top: 10px" v-loading="loading">
          <el-tabs v-model="categoryCode" @tab-click="mockData">
            <el-tab-pane v-for="item in commonUtils.getDictPara('law_type')"
                         :key="item.code"
                         :label="item.name"
                         :name="item.code"></el-tab-pane>
          </el-tabs>
          <div style="margin-top: 10px;min-height: 100px;">
            <no-data-div v-if="pageParam.total === 0"></no-data-div>
            <div class="item" v-for="item in laws" :key="item.id">
              <h2>
                <my-link :href="'/laws/detail?sid='+item.id+'&viewType='+item.viewType+'&tableType=web_laws'" :right="{tableType:'web_laws',rowId:item.id,viewType:item.viewType}">【{{item.code}}】{{item.title}}</my-link>
                <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                <resource-price :values="item"></resource-price>
              </h2>
              <p>{{item.description}}</p>
              <div>
                <span>{{item.publishTime|dateToStr}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>来源：{{item.origin}}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <ad-right></ad-right>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { list } from '@/api/resource/law'

export default {
  name: 'index',
  data () {
    return {
      categoryCode: '1',
      activeNews: '1',
      searchText: '',
      laws: [],
      loading: false,
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  mounted () {
    this.mockData()
  },
  methods: {
    // 获取客户列表
    mockData () {
      this.loading = true
      // 请求获取数据
      let param = {}
      param.categoryCode = this.categoryCode
      param.keyWord = this.searchText
      param.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize,
        orderBy: 'createTime'
      }
      list(param)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.laws = result.bizData
            // 分页赋值
            this.pageParam.total = result.total
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.mockData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .item {
    h2 {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      padding: 0;
      margin: 0;
      a {
        text-decoration: none;
        color: #303133;
        font-size: 18px;
        font-weight: normal;
        display: inline-block;
        height: 22px;
        line-height: 22px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover {
          color: #32A08C;
        }
      }
    }
    p {
      text-indent:2em;
      color: #959595;
      font-size: 14px;
      line-height: 20px;
      height: 60px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }

</style>
